import { Component, inject } from '@angular/core';
import { APP_CONFIG } from '../../core/app-config.token';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  cfg = inject(APP_CONFIG);
  readonly encodeURIComponent = encodeURIComponent;
}
